exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header--2fUBt {\n  display: grid;\n  width: 100%;\n  grid-template-columns: [type] 100px [pan] 145px [exp] 70px [status] 165px [pin-counter] 75px [switch-sms] 75px [amount] 1fr [currency] 45px;\n  grid-auto-columns: 1fr;\n  grid-column-gap: 10px;\n  padding: 10px 10px 10px 44px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.header--2fUBt > * {\n  -ms-flex-item-align: center;\n      align-self: center;\n  justify-self: center;\n  color: #878787;\n  font-weight: 400;\n  font-size: 14px;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header--2fUBt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/emission/cards/CardsList/CardsList.m.scss
// module id = 1369
// module chunks = 0